/**
 * @module Model
 */

import { Country } from '@app/models/country.model';

/**
 * Class representing an order template in the application.
 *
 * @class
 * @model
 */
export class OrderTemplate {
	/**
	 * The unique identifier for the order template.
	 * @type {number}
	 */
	id: number;

	/**
	 * The prefix associated with the order template.
	 * @type {string}
	 */
	prefix: string;

	/**
	 * The title of the order template.
	 * @type {string}
	 */
	title: string;

	/**
	 * The alias for the order template.
	 * @type {string}
	 */
	alias: string;

	/**
	 * The order number indicating the sequence of the template.
	 * @type {number}
	 */
	order: number;

	/**
	 * Country associated with the order template (optional).
	 * @type {Country | undefined}
	 */
	country?: Country;

	/**
	 * Creates an instance of the OrderTemplate class.
	 *
	 * @constructor
	 * @param {number} id - The unique identifier for the order template.
	 */
	constructor(id: number) {
		this.id = id;
	}
}
